/**
 * Public env accessors for the customer portal.
 *
 * VITE_* values are embedded in browser code. Never put server secrets in
 * these variables.
 */
export const getPublicApiUrl = (): string | undefined =>
  import.meta.env.VITE_API_URL;

export const getPublicConfigFlavor = (): string | undefined =>
  import.meta.env.VITE_CONFIG_FLAVOR;
